import { Cell, Text } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";

const OtherLink = _ref => {
  let {
    title,
    url,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(Cell, {
    type: Cell.Type.Navigating,
    body: /*#__PURE__*/_jsx(Text, {
      text: title,
      truncate: true
    }),
    url: url,
    urlProps: {
      title
    },
    onClick: onClick
  });
};

export default OtherLink;